import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { fmtHM, parseHM } from "@/lib/interventions";

export const HoursInput = ({ value, onChange, testId, disabled, className = "w-28" }) => {
  const [t, setT] = useState(value == null ? "" : fmtHM(value));
  const [err, setErr] = useState(false);
  useEffect(() => { if (value == null || parseHM(t) !== value) setT(value == null ? "" : fmtHM(value)); }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  const change = (s) => {
    setT(s);
    const m = parseHM(s);
    setErr(Number.isNaN(m));
    if (!Number.isNaN(m)) onChange(m);
  };
  return (
    <div className="space-y-1">
      <div className="flex items-center gap-2">
        <Input inputMode="decimal" placeholder="0,30" value={t} disabled={disabled} onChange={(e) => change(e.target.value)} className={`text-center ${className}`} data-testid={testId} />
        <span className="text-xs text-slate-500">ore (H,MM)</span>
      </div>
      {err && <p className="text-xs text-red-600" data-testid={`${testId}-error`}>Formato H,MM: minuti da 00 a 59, oppure ,5 per la mezz'ora (es. 0,30 · 1 · 1,5 · 1,15 · 2,45)</p>}
    </div>
  );
};
